<template>
   <detail-layout v-if="true">
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item v-if="!!form.guid" prop="guid">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('configsaml2.details.guid') }}</label>
            <el-input class="w-full" v-model="form.guid" :disabled="true" clearable />
          </el-form-item>
          <el-form-item prop="Ruta">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('configsaml2.details.urlSAML2') }}</label>
            <el-input class="w-full" v-model="form.Ruta" :disabled="isRoleUserOrConsulta" clearable />
          </el-form-item>
          <el-form-item prop="Issuer">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('configsaml2.details.issuer') }}</label>
            <el-input class="w-full" v-model="form.Issuer" :disabled="isRoleUserOrConsulta" clearable />
          </el-form-item>
          <el-form-item prop="file" ref="uploadpfxref">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('configsaml2.details.cert') }}</label>
            <Upload
              ref="upload"
              accept=".cer"
              id="pfxselector"
              class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
              :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
              drag
              action="#"
              :show-file-list="false"
              :multiple="false"
              :auto-upload=false
              :on-remove="handleRemove"
              :on-change="handleChange">
              <i class="el-icon-upload"></i>
              <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
              <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
            </Upload>
          </el-form-item>

        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
                :loading="isGeneralLoading" :disabled="isRoleUserOrConsulta" />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { Upload } from 'element-ui'
import { getSaml2Config } from '@/services/configurations/saml2/getSaml2Config'
import { updateSaml2Config } from '@/services/configurations/saml2/updateSaml2Config'
import { getClient } from '@/services/clients/getClient'
import { i18n } from '@/i18n'

export default {
  components: {
    DetailLayout,
    Upload
  },
  data () {
    return {
      header: {
        title: i18n.t('configsaml2.header'),
        icon: 'config',
        url: 'configurations/clients/details',
        breadcrumb: [],
        nav: [],
        params: this.$route.params
      },
      rules: {
        ClientID: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ], 
        TenantID: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
      },
      form: {
        guid: '',
        Ruta: '',
        Issuer: '',
        Cert: ''
      },
      file: {
        name: '',
        b64: ''
      },
    }
  },

  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    id: function () {
      return this.$route.params.id ? this.$route.params.id : this.$store.getters['auth/user'].idCliente
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },

  methods: {
    goBack: function () {
      this.$router.push({ name: 'configurations/clients/details', params: this.$route.params.id })
    },
    setDataForm: function (saml2Config) {
      this.form.guid = saml2Config?.Guid ?? ''
      this.form.Ruta = saml2Config?.Ruta ?? ''
      this.form.Issuer = saml2Config?.Issuer ?? ''
      this.file.b64 = saml2Config?.Cert ?? ''
      this.file.name = saml2Config?.Cert ? i18n.t('configsaml2.details.certupload'): null
    },

    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCliente: this.id,
              Ruta: this.form.Ruta,
              Issuer: this.form.Issuer,
              Cert: this.file.b64
            }
            var response = await updateSaml2Config(data)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [' + response.codError + ']')
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
  },

  created: async function () {
    this.$store.commit('setIsLoading', true)
    var params = { idCliente: this.id }
    var response = await getSaml2Config(params)
    this.setDataForm(response?.respuesta)
    this.$store.commit('setIsLoading', false)
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 3 ? 'configurationssa' : 'configurations',
      name: i18n.t('configurations.header')
    })
    breadcrumbs.push({
      path: 'configurations/clients',
      name: i18n.t('clients.header')
    })
    if (this.id !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.Cliente.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.Cliente.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs
  }
}

  
</script>

<style>

</style>
